<div class="subscription-component">
  <div class="subscription-header">
    <span class="subscription-label">My Subscriptions</span>
    <p class="subscription-plan-detail" *ngIf="!isAdmin">
      <b>Current Plan:</b>
      <span class="selected-plan-chip" [ngClass]="{ 'selected-plan-chip-expired': isUserPlanExpired() }">{{
        getSelectedPlanChipLabel() }}</span>
    </p>
    <p class="subscription-description">
      {{ getSelectedPlanInfoText() }}<ng-container *ngIf="managingOrganizationName as orgName">
        <ng-container *ngIf="getSelectedPlanInfoText()"> &middot; managed by </ng-container>
        <ng-container *ngIf="!getSelectedPlanInfoText()">Managed by</ng-container>
        <b>{{ orgName }}</b>
      </ng-container>
    </p>
    <button class="refresh-btn" title="Refresh Subscription" type="button" (click)="onRefreshSubscriptionBtnClick()">
      <span class="material-symbols-outlined"> autorenew </span>
      Refresh
    </button>
  </div>

  <div class="subscription-tabs">
    <mat-tab-group mat-stretch-tabs="false" style="height: 100%" mat-align-tabs="start"
      [selectedIndex]="activeTab === 'plans' ? 0 : 1" (selectedTabChange)="onTabChange($event.index)">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" title="{{ 'Subscriptions.Labels.TabLabelPlans' | translate }}">
            {{ 'Subscriptions.Labels.TabLabelPlans' | translate }}
          </span>
        </ng-template>
        <div [ngSwitch]="subscriptions.state.status">
          <!-- Loading or Not Fetched State -->
          <div *ngSwitchCase="'Loading'">
            <div class="subscription-status">Loading Subscriptions Plans ...</div>
          </div>
          <div *ngSwitchCase="'NotFetched'">
            <div class="subscription-status">Loading Subscriptions Plans ...</div>
          </div>
          <!-- Success State -->
          <div *ngSwitchCase="'Success'">
            <div *ngIf="subscriptions.plans.length > 0" class="plans-container">
              <div class="plans-list">
                <ng-container *ngFor="let item of subscriptions.plans">
                  <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: item }">
                  </ng-container>
                </ng-container>
              </div>
              <button class="skip-subscription-button" (click)="onSkipSubscriptionBtnClick()" title="Skip"
                *ngIf="showSubscriptionAsDialog">
                Skip
              </button>
            </div>
            <div *ngIf="subscriptions.plans.length === 0">
              <div class="subscription-status">No subscription plans available.</div>
            </div>
          </div>
          <!-- Failure State -->
          <div *ngSwitchCase="'Failure'" class="error-message">
            <div class="subscription-status text-danger">Error: Failed to load subscription plans.</div>
          </div>
        </div>
      </mat-tab>

      <mat-tab *ngIf="!showSubscriptionAsDialog">
        <ng-template mat-tab-label>
          <span class="tab-label" title="{{ 'Subscriptions.Labels.TabLabelHistory' | translate }}">
            {{ 'Subscriptions.Labels.TabLabelHistory' | translate }}
          </span>
        </ng-template>
        <div class="billing-history-container">
          <div [ngSwitch]="ordersState.status">
            <!-- Loading or Not Fetched State -->
            <div *ngSwitchCase="'Loading'">
              <div class="subscription-status">Loading Billing History...</div>
            </div>
            <div *ngSwitchCase="'NotFetched'">
              <div class="subscription-status">Loading Billing History...</div>
            </div>
            <!-- Success State -->
            <div *ngSwitchCase="'Success'">
              <div *ngIf="dataSource.data.length > 0" class="table-container">
                <table mat-table [dataSource]="dataSource">
                  <ng-container *ngFor="let column of billingHistoryTableColumns" [matColumnDef]="column.bindingValue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.header }}</th>
                    <td mat-cell *matCellDef="let row">
                      <ng-container *ngIf="column.bindingValue === 'action'; else defaultCell">
                        <button mat-button style="background-color: whitesmoke; width: 130px;"
                          (click)="onActionClick(row)" [title]="row.Action">
                          {{row.Action}}
                        </button>
                      </ng-container>
                      <ng-template #defaultCell>
                        <span [title]="row[column.bindingValue]">{{ row[column.bindingValue]
                          }}</span>
                      </ng-template>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </div>
              <div *ngIf="dataSource.data.length === 0">
                <div class="subscription-status">No billing history available.</div>
              </div>
            </div>
            <!-- Failure State -->
            <div *ngSwitchCase="'Failure'" class="error-message">
              <div class="subscription-status text-danger">Error: Failed to load billing history.</div>
            </div>
          </div>
          <mat-paginator *ngIf="ordersState.status === 'Success' && dataSource.data.length > 0" [pageSize]="pageSize"
            [pageSizeOptions]="[5]" (page)="onPageChange($event)" [length]="totalItemsLength" [disabled]="disabled"
            [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions" [hidePageSize]="hidePageSize"
            [pageIndex]="pageIndex" aria-label="Select page of orders">
          </mat-paginator>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Template for Mat Card -->
  <ng-template #cardTemplate let-data>
    <app-subscription-plan-card [subscriptionPlan]="data" [hasPendingOrder]="hasPendingOrder"
      [managedByOrganization]="!!organizationSubscription" [trialDaysRemaining]="getTrialDaysRemaining()"
      (subscriptionPlanClick)="onSubscriptionPlanClick(data, getCardInfo(data).ButtonLabel)">
    </app-subscription-plan-card>
  </ng-template>
</div>